import { motion } from "framer-motion";
import {
  Workflow,
  Headphones,
  ShieldCheck,
  BarChart3,
  FileText,
  Sparkles,
} from "lucide-react";

import Section from "@/components/layout/Section";
import Container from "@/components/layout/Container";

const items = [
  {
    title: "PROCESS DRIVEN OPERATIONS",
    text: "Workflows stabilize consistency and scale operations.",
    icon: Workflow,
  },
  {
    title: "ALWAYS ON GUEST SUPPORT",
    text: "Guest communication handled across the stay lifecycle.",
    icon: Headphones,
  },
  {
    title: "QUALITY & COMPLIANCE",
    text: "Standards protect property value and service quality.",
    icon: ShieldCheck,
  },
  {
    title: "MARKET AWARE DECISIONS",
    text: "Pricing adapts to demand and local trends.",
    icon: BarChart3,
  },
  {
    title: "OWNER REPORTING",
    text: "Clear visibility into revenue and occupancy.",
    icon: FileText,
  },
  {
    title: "CONTINUOUS OPTIMISATION",
    text: "Listings improve with real performance data.",
    icon: Sparkles,
  },
];

const columns = [
  items.filter((_, i) => i % 2 === 0),
  items.filter((_, i) => i % 2 !== 0),
];

export default function SolutionsTrust() {

  return (

    <Section background="bg-bg-light" padding="lg">

      <Container>

        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-center">

          {/* LEFT */}
          <div className="max-w-[420px]">

            <span className="text-small font-semibold uppercase tracking-wide text-text-muted">
              Why Zenia
            </span>

            <h3 className="mt-5 text-display font-extrabold text-text-primary">
              Built as a system, not a service
            </h3>

            <p className="mt-6 text-body text-text-muted leading-relaxed">
              Zenia combines operations, pricing and guest experience into a
              structured system that continuously improves performance.
            </p>

          </div>

          {/* RIGHT FLOW */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 h-[420px] overflow-hidden">

            {columns.map((col, colIndex) => {

              const repeated = [...col, ...col, ...col];

              return (
                <motion.div
                  key={colIndex}
                  className="flex flex-col gap-5"
                  animate={{ y: ["0%", "-50%"] }}
                  transition={{
                    duration: 20 + colIndex * 4,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                >

                  {repeated.map((item, i) => {

                    const Icon = item.icon;

                    return (
                      <div
                        key={i}
                        className="
                          relative rounded-xl
                          border border-border-soft
                          bg-bg-surface p-4
                        "
                      >

                        {/* DARK STRIP */}
                        <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-brand-secondary opacity-60" />

                        {/* LIVE DOT */}
                        <div className="absolute top-3 right-3 w-2 h-2 rounded-full bg-brand-secondary opacity-70 animate-pulse" />

                        <div className="flex items-start gap-3">

                          <div className="
                            w-9 h-9 rounded-lg flex items-center justify-center
                            bg-bg-light border border-border-soft
                          ">
                            <Icon size={16} className="text-text-primary" />
                          </div>

                          <div>
                            <div className="text-[12px] font-semibold text-text-primary tracking-wide">
                              {item.title}
                            </div>

                            <p className="text-[13px] text-text-muted mt-1 leading-relaxed">
                              {item.text}
                            </p>
                          </div>

                        </div>

                      </div>
                    );

                  })}

                </motion.div>
              );

            })}

          </div>

        </div>

      </Container>

    </Section>
  );
}